module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page-vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page-viii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-dedication"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part001"
    }
  }, [_vm._v("PART I"), _c('br'), _vm._v(" Getting Organized: How to Think Differently")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Go with the FLOW")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Slow Down, You Move Too Fast")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Fresh Eyes, Fresh Space")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Fear Creates Clutter")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Who Are You Now? or, Will You Really Use That Bread Maker?")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Don’t Let Paper Push You Around")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Better Systems = Less Thinking")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion to Part I")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II"), _c('br'), _vm._v(" Staying Organized in the Real World")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Keep Your Stock Shipshape"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Habit: Take Inventory")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("If You Structure It, You Will Do It"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Habit: Block Out Time")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-chapter013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('span', {
    staticClass: "pad2"
  }, [_vm._v("Get Back to Neutral"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Habit: Do a Last Sweep")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-chapter014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 11")]), _vm._v(" "), _c('span', {
    staticClass: "pad2"
  }, [_vm._v("Healthy Boundaries, Healthy Homes"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Habit: Set Limits on Stuff")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-chapter015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 12")]), _vm._v(" "), _c('span', {
    staticClass: "pad2"
  }, [_vm._v("You Get What You Pay For"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Habit: Buy Less but Better")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-chapter016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 13")]), _vm._v(" "), _c('span', {
    staticClass: "pad2"
  }, [_vm._v("Secrets of an Organizing Ninja"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Habit: Ten-Minute Maintenance")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-chapter017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "special1"
  }, [_vm._v("CHAPTER 14")]), _vm._v(" "), _c('span', {
    staticClass: "pad2"
  }, [_vm._v("What Your Grandmother Could Have Told You"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Habit: Cultivate Consistency")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter3",
    attrs: {
      "id": "toc-chapter018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion to Part II")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix1",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-acknowledgements"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-index"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-personblurb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/personblurb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden-tag",
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', [_vm._v("Navigation")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/introduction"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0